/**
 * Created by noOne on 04/12/2017.
 */
"use strict";

import Sprite3D from "./Sprite3D";

/**
 * @class
 */
export default class Present extends Sprite3D {
    /**
     * @param texName {String} - texture name
     * @param holder {*|PIXI.projection.Container2d} - optional holder to add to
     */
    constructor(texName, holder) {
        super(texName, holder);

        /**
         * @type {string}
         * @private
         */
        this._type = "health";

        /**
         * @type {*|PIXI.projection.Container2d}
         * @private
         */
        this._container3D = holder;

        let partHolder = new PIXI.Container();
        this.addChild(partHolder);

        this._emitter = P3.createParticles(partHolder, "part_emitter_heart", {
            name: "part_heart_",
            count: 1
        }, null, false);
        this._emitter.emit = false;

        // this.addChild(this.view);//to top
        Common.hearts.push(this);

        this.dead = false;

        this.tutCB = null;

        this.animatedShadow();
    }

    animatedShadow() {
        const shadow = P3.createSprite(Common.shadowTexture, this);
        shadow.y = this._view.y + 150;
        shadow.scale.set(1.25);
        shadow.alpha = 0.15;

        TweenMax.to(shadow, 0.75 * 0.5, {y: 350, ease: Power0.easeNone, yoyo: true, repeat: 1});
        //  shadow.visible = false;
    }

    update() {
        if (!this.dead) {
            if (this._emitter) this._emitter.update(deltaTime);
        }
    }

    reveal() {
        this._emitter.emit = true;
        //  this.view.tint = 0xffffff;

        this.view.interactive = true;
        this.view.mousedown = this.view.touchstart = this.inputdown.bind(this);

        delay(()=> {
            //start blinking

            this._view.alpha = 0;


            delay(()=> {
                //start blinking

                this._view.alpha = 1;

                delay(()=> {
                    //start blinking

                    this._view.alpha = 0;


                    delay(()=> {
                        //start blinking

                        this._view.alpha = 1;


                        delay(()=> {
                            //start blinking
                            if(!this.skipDecay){
                                TweenMax.to(this._view, 1, {
                                    alpha: 0,
                                    onComplete: ()=> {

                                        this.destroy();

                                    }
                                });
                            }

                        }, 0.2, this);
                    }, 0.2, this);
                }, 0.2, this);
            }, 0.2, this);
        }, 10, this);
    }

    inputdown(event) {
        Common.audio.playSound("sfx_heart_pickup_2");

        this.dead = true;
        Common.healthInLevel = false;
        switch (this._type) {
            case "health":
                if (Common.scoreManager.gotBullets()) {
                    Common.scoreManager.useBullet();
                    Common.scoreManager.refillHealth();
                    this.destroy({children: true});
                }
                break;
            default:
                console.error("unknown present type");
                break;
        }

        if (this.tutCB) this.tutCB();
    }
}